import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root',
})
export class LogService {
	constructor(private snackBar: MatSnackBar) {}
	log(...msg) {
		const dateTime = moment(new Date()).format('D-MMM-YYYY, h:mm:ss a');
		const labelStyle = 'background: blue; color: white; font-size: 14px; font-weight: bold;';
		const textStyle = 'background: blue; color: white; font-size: 12px;';
		environment.LOG_CONFIGS.enableLogs ? console.log(`%cLog @ ${dateTime}:\n%c${msg}`, labelStyle, textStyle) : null;
	}

	info(...msg) {
		const dateTime = moment(new Date()).format('D-MMM-YYYY, h:mm:ss a');
		const labelStyle = 'background: green; color: white; font-size: 14px; font-weight: bold;';
		const textStyle = 'background: green; color: white; font-size: 12px;';
		environment.LOG_CONFIGS.enableInfoLogs
			? console.info(`%cInfo @ ${dateTime}:\n%c${msg}`, labelStyle, textStyle)
			: null;
	}

	table(msg) {
		environment.LOG_CONFIGS.enableLogs ? console.table([msg]) : null;
	}

	error(...error) {
		const dateTime = moment(new Date()).format('D-MMM-YYYY, h:mm:ss a');
		const labelStyle = 'background: red; color: white; font-size: 14px; font-weight: bold;';
		const textStyle = 'background: red; color: white; font-size: 12px;';
		environment.LOG_CONFIGS.enableErrorLogs
			? console.trace(`%cError @ ${dateTime}:\n%c${error}`, labelStyle, textStyle)
			: null;
	}

	/**
	 * show SnackBar
	 * @param message
	 */
	showSnackBar(message, duration = 5000) {
		this.snackBar.open(message, 'Close', {
			duration: duration,
			panelClass: 'snackbar',
		});
	}
}
